import { Card } from "react-bootstrap";
import styled from "styled-components";

export const ContainerCard = styled(Card)`
  box-shadow: 0 0 5px var(--color-gray);
  background-color: var(--gray-800);
`;

export const BorderCard = styled(Card)`
  background-color: var(--gray-800);
  margin-top: 4rem;

  border-radius: 8px;
  overflow: hidden;
`;
